export function IntentRing({ score, size = 88, stroke = 8, label = true }) {
  const value = score == null ? 0 : score;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (value / 100) * c;
  const color = value >= 90 ? "#059669" : value >= 70 ? "#d97706" : "#e11d48";
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid="intent-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#e6e4dd" strokeWidth={stroke} />
        <circle
          cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
          strokeDasharray={c} strokeDashoffset={score == null ? c : offset} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.9s cubic-bezier(0.16,1,0.3,1)" }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="font-display tabnums leading-none" style={{ fontSize: size * 0.3, color }}>
          {score == null ? "—" : value}
        </span>
        {label && <span className="text-[9px] uppercase tracking-[0.15em] text-[#94a3b8] mt-0.5">Fidelity</span>}
      </div>
    </div>
  );
}
